import { gsap } from "gsap";
import { useEffect, useRef } from "react";
import s from "./ToggleSound.module.scss";
import { useStore } from "../../store/store";
import { lerp } from "../../utils/Maths";
import AudioManager from "../../utils/AudioManager";
import Volume from "../Volume/Volume";
import { useTranslation } from "react-i18next";

const ToggleSound = () => {
  const { t } = useTranslation();

  const toggleRef = useRef();
  const cursor = useRef({
    x: 0,
    y: 0,
  });

  const target = useRef({
    x: 0,
    y: 0,
  });

  const rafId = useRef(null);
  const speed = 0.4;
  const hasFadeOut = useRef(false);

  const setVolume = useStore((state) => state.setVolume);
  const setHasInteracted = useStore((state) => state.setHasInteracted);
  const isHoveringTerms = useStore((state) => state.isHoveringTerms);

  useEffect(() => {
    cursor.current.x = window.innerWidth / 2;
    target.current.x = window.innerWidth / 2;

    cursor.current.y = window.innerHeight / 2;
    target.current.y = window.innerHeight / 2;

    const width = toggleRef.current.offsetWidth;
    const height = toggleRef.current.offsetHeight;

    const onMouseMove = (e) => {
      if (hasFadeOut.current === true) {
        window.removeEventListener("mousemove", onMouseMove);
        return;
      }

      toggleRef.current.classList.add(s.hasMoved);

      target.current.x = e.clientX - width * 0.5;
      target.current.y = e.clientY - height * 0.5;

      if (!rafId.current) rafId.current = requestAnimationFrame(update);
    };

    const update = () => {
      cursor.current.x = lerp(cursor.current.x, target.current.x, speed);
      cursor.current.y = lerp(cursor.current.y, target.current.y, speed);

      toggleRef.current.style.transform = `translate3d(${cursor.current.x}px, ${cursor.current.y}px, 0px)`;

      const delta = Math.sqrt(
        Math.pow(target.current.x - cursor.current.x, 2) +
          Math.pow(target.current.y - cursor.current.y, 2)
      );

      if (delta < 0.001) {
        cancelAnimationFrame(rafId.current);
        rafId.current = null;

        return;
      }

      rafId.current = requestAnimationFrame(update);
    };

    // gsap.ticker.add(update);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("click", onClick);

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("click", onClick);

      cancelAnimationFrame(rafId.current);
    };
  }, []);

  const onClick = () => {
    AudioManager.play();
    toggleRef.current.classList.remove(s.hasMoved);
    toggleRef.current.classList.add(s.hasClicked);

    hasFadeOut.current = true;
    setVolume(1);

    setTimeout(() => {
      setHasInteracted(true);
    }, 500);

    cancelAnimationFrame(rafId.current);
    window.removeEventListener("click", onClick);
  };

  return (
    <div
      ref={toggleRef}
      className={`${s.toggle} ${isHoveringTerms ? s.isHoveringTerms : ""}`}
    >
      {/* <Volume /> */}
      <span>{t("clickToEnableSound")}</span>
    </div>
  );
};

export default ToggleSound;
